import React, { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import { savePostLoginRedirect } from '../../services/authService';
import LoadingSpinner from '../common/LoadingSpinner';

/**
 * Route-Wrapper fuer geschuetzte Bereiche:
 * - waehrend der Token-Validierung: zentrierter Lade-Spinner
 * - nicht angemeldet: angeforderten Pfad merken (Deep-Link-Erhalt,
 *   siehe AuthCallbackPage) und Redirect auf /login
 * - angemeldet: Outlet (Kind-Routen)
 */
function ProtectedRoute(): React.JSX.Element {
  const { status } = useAuth();
  const location = useLocation();

  // Deep-Link-Erhalt: Beim Redirect auf /login den urspruenglich
  // angeforderten Pfad (inkl. Query) merken; die AuthCallbackPage
  // navigiert nach erfolgreichem Login dorthin.
  useEffect(() => {
    if (status === 'anonymous') {
      savePostLoginRedirect(location.pathname + location.search);
    }
  }, [status, location.pathname, location.search]);

  if (status === 'loading') {
    return (
      <div
        id="auth-loading"
        className="d-flex align-items-center justify-content-center min-vh-100"
      >
        <LoadingSpinner id="auth-loading-spinner" />
      </div>
    );
  }

  if (status === 'anonymous') {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}

export default ProtectedRoute;
